import axios from 'axios';
import { getBaseUrl } from '@/utils/baseUrl';

export const getBlogPost = async (lang) => {
  try {
    const baseUrl = getBaseUrl();
    const { data } = await axios.get(`${baseUrl}/blog`, {
      params: {
        lang,
        urlParam: 'posts',
        tags: [302, 281, 303, 188],
        _embed: ''
      }
    });
    return data;
  } catch (e) {
    throw e;
  }
};